import { render } from "./WithdrawTransfer.vue?vue&type=template&id=b4f22f0a"
import script from "./WithdrawTransfer.vue?vue&type=script&lang=js"
export * from "./WithdrawTransfer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__